import types from './types';

const InitialState = {
    loaded: false,
    popups: [
        // {
        //     id: "8b3a9e5f-6d91-47c2-a8b4-3f7c9d1e52ab",
        //     type: "testyourluck",
        //     details: {
        //         title: "Test Your Luck is available! 🍀",
        //         text: "Your lucky bonus is ready. Give it a shot!"
        //     },
        //     action: {
        //         type: "navigate",
        //         path: "/testyourluck"
        //     }
        // }
    ]
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.hide:
            return {
                ...state,
                popups: state.popups.filter(popup => popup.id !== payload)
            }
        case types.loaded:
            return {
                ...state,
                loaded: true
            }
        default:
            return state;
    }
}